import { api } from '@/services/api';
import { processApiError } from '@repo/utils';
import {
  AdminRegionsResponseDto,
  AdminRegionInfoDto,
  CreateRegionDto,
  UpdateRegionDto,
  GetAdminRegionsDto,
  AdminRegionsFilterDto,
  Prisma,
} from '@repo/common-types';
import { RegionsFilterLocal } from '@/pages/agents/Regions/regions-query-reducer';

/**
 * Convert local filter format to API format for regions
 */
export const convertRegionsFilterToApiFormat = (filter: RegionsFilterLocal): AdminRegionsFilterDto => {
  const apiFilter: AdminRegionsFilterDto = {
    search: filter.search,
    countryName: filter.countryName,
  };

  if (typeof filter.hasSubdivisions === 'boolean') {
    apiFilter.hasSubdivisions = filter.hasSubdivisions;
  }

  if (typeof filter.hasAgentDeals === 'boolean') {
    apiFilter.hasAgentDeals = filter.hasAgentDeals;
  }

  return apiFilter;
};

export const fetchRegionsRest = async (params: {
  skip: number;
  take: number;
  filter?: RegionsFilterLocal;
  sorts?: Array<{ field: string; order: Prisma.SortOrder }>;
}): Promise<AdminRegionsResponseDto> => {
  try {
    // Convert local filter to API format
    const apiParams: GetAdminRegionsDto = {
      skip: params.skip,
      take: params.take,
      sorts: params.sorts,
      filter: params.filter ? convertRegionsFilterToApiFormat(params.filter) : undefined,
    };

    const response = await api.get('/v1/admin/regions', { params: apiParams });
    return response.data;
  } catch (error) {
    const userFriendlyMessage = processApiError(error);
    throw new Error(userFriendlyMessage);
  }
};

export const createRegionRest = async (regionData: CreateRegionDto): Promise<AdminRegionInfoDto> => {
  try {
    const response = await api.post('/v1/admin/regions', regionData);
    return response.data;
  } catch (error) {
    const userFriendlyMessage = processApiError(error);
    throw new Error(userFriendlyMessage);
  }
};

export const updateRegionRest = async (regionId: string, regionData: UpdateRegionDto): Promise<AdminRegionInfoDto> => {
  try {
    const response = await api.put(`/v1/admin/regions/${regionId}`, regionData);
    return response.data;
  } catch (error) {
    const userFriendlyMessage = processApiError(error);
    throw new Error(userFriendlyMessage);
  }
};

export const deleteRegionRest = async (regionId: string): Promise<void> => {
  try {
    await api.delete(`/v1/admin/regions/${regionId}`);
  } catch (error) {
    const userFriendlyMessage = processApiError(error);
    throw new Error(userFriendlyMessage);
  }
};

export const getRegionRest = async (regionId: string): Promise<AdminRegionInfoDto> => {
  try {
    const response = await api.get(`/v1/admin/regions/${regionId}`);
    return response.data;
  } catch (error) {
    const userFriendlyMessage = processApiError(error);
    throw new Error(userFriendlyMessage);
  }
};
